import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Success from '../../Assets/images/success2.png'
import Button from '../SelectValue/Button';
import { Link } from 'react-router-dom';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
};

export default function SavingSuccess({ open, handleClose, type }) {

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} className=' rounded-2xl outline-none focus:outline-none focus:border-none'>
            <div className=' grid h-[45vh] place-items-center p-6'>
              <div className=' w-full text-center'>
                <img src={Success} className=' mb-5 mx-auto w-20 h-20' alt='Success' />
                <p className=' text-back-color2 font-[600] text-[18px] mb-8 capitalize'>
                  {type === 'rent' ? 'Rent' : 'Target'} savings plan created
                </p>
                <div className=' grid grid-cols-1 w-full'>
                  <Button
                    name='Go to plan'
                    bool={true}
                    onClick={handleClose}
                  />
                </div>

              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}